<template>
    <div style="padding: 20px;">
        <div id="login-container">
            <a href="https://bugfer.com"><img src="/img/logo_dark.png" alt="" style="max-width: 200px;margin: 25px auto 40px auto;display: block;"></a>
            <b-field label="Email">
                <b-input type="email" v-model="email"></b-input>
            </b-field>
            <b-field label="Password">
                <b-input type="password" v-model="password"></b-input>
            </b-field>
            <b-button @click="Login" type="is-primary" style="width:100%; margin-top: 25px;">Login</b-button>
            <div class="center">
                <a @click="showRegister">Signup</a>
            </div>
        </div>
        <div id="register-container">
            <a href="https://bugfer.com"><img src="/img/logo_dark.png" alt="" style="max-width: 200px;margin: 25px auto 40px auto;display: block;"></a>
            <div class="row">
                <div class="col-sm-6" style="padding-right: 5px;">
                    <b-field label="First name">
                        <b-input type="text" pattern=".{2,30}" ref="name" validation-message="Must have at least 2 characters" v-model="name" required></b-input>
                    </b-field>
                </div>
                <div class="col-sm-6" style="padding-left: 5px;">
                    <b-field label="Last name">
                        <b-input type="text" pattern=".{2,30}" ref="last_name" validation-message="Must have at least 2 characters" v-model="last_name" required></b-input>
                    </b-field>
                </div>
            </div>
            <b-field label="Email">
                <b-input type="email" v-model="email" ref="email" required></b-input>
            </b-field>
            <b-field label="Password">
                <b-input type="password" v-model="password" ref="password" required></b-input>
            </b-field>
            <b-button @click="register" type="is-primary" style="width:100%;">Signup</b-button>
            <div class="center">
                <a @click="showLogin">Login</a>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import {loginUser, registerUser} from '../../logic/account'
    import {getCountries} from '../../logic/global'
    import {CoolSelect} from "vue-cool-select";
    import { isNullOrUndefined } from 'util';

    let from = ''
    export default {
        data(){
            return {
                email : "",
                password : "",
                name: "",
                last_name: "",
                phone: "",
                is_logged: localStorage.getItem('jwt'),
                from: from,
                postalcode: "",
                country: "",
                items: getCountries()
            }
        },
        components: {CoolSelect},
        methods: {
            changeInputValue: function(model, value){
                if (model == 'email'){
                    this.email = value
                }else{
                    if (model == 'password'){
                        this.password = value
                    }
                }
            },
            showLogin(){
                let login = document.getElementById("login-container")
                let register = document.getElementById("register-container")
                login.style.display = "block"
                register.style.display = "none"
            },
            showRegister(){
                let login = document.getElementById("login-container")
                let register = document.getElementById("register-container")
                login.style.display = "none"
                register.style.display = "block"
            },
            Login(e){
                let _this = this;
                e.preventDefault()
                if (this.password.length > 0) {
                    loginUser({
                        email: this.email,
                        password: this.password
                    }).then(response => {
                        localStorage.clear();
                        localStorage.setItem('jwt',response.data.token)
                        if (localStorage.getItem('jwt') != null){
                            this.$emit('loggedIn')
                            this.$router.push({name: "workspaces"})
                        }
                    }).catch(error => {
                        if(isNullOrUndefined(error.response)){
                            _this.showSuccessMsg("Something went wrong. Try again later or contact support.", "is-danger")
                        }else{
                            // If status code exists
                            if(error.response.status == 400 && error.response.data.code == "001"){
                                this.$router.push({name: "confirmEmail"})
                            }else{
                                if(error.response.status == 400){
                                    _this.showSuccessMsg("Incorrect email or password", "is-danger")
                                }
                            }
                        }
                    })
                }
            },
            showSuccessMsg: function(message, msg_type){
                this.$toast.open({message: message, type: msg_type})
            },
            register(e){
                let _this = this;
                let isNameValid = this.$refs.name.checkHtml5Validity()
                let isLastNameValid = this.$refs.last_name.checkHtml5Validity()
                let isPaswordValid = this.$refs.password.checkHtml5Validity()
                let isEmailValid = this.$refs.email.checkHtml5Validity()

                if(!isEmailValid){
                    _this.showSuccessMsg("Email is not valid", "is-danger")
                }

                if(!isPaswordValid){
                    _this.showSuccessMsg("The password must be at least 6 characters long", "is-danger")
                }

                if(!isNameValid){
                    _this.showSuccessMsg("'First name' must have at least 2 characters", "is-danger")
                }

                if(!isLastNameValid){
                    _this.showSuccessMsg("'Last name' must have at least 2 characters", "is-danger")
                }

                if (isNameValid && isLastNameValid && isPaswordValid && isEmailValid) {
                    let payload = {
                        username: this.email,
                        email: this.email,
                        password: this.password,
                        first_name: this.name,
                        last_name: this.last_name,
                        password_confirmation: this.password
                    }

                    registerUser(payload).then(response => {
                        _this.showSuccessMsg("User created", "is-success")
                        _this.showLogin()
                    }).catch(function (error) {
                        if(error.response.status == 400 && error.response.data.hasOwnProperty('email')){
                            _this.showSuccessMsg("That email address is already in use.", "is-danger")
                        }else{
                            if(error.response.status == 400 && (error.response.data.hasOwnProperty('first_name') || error.response.data.hasOwnProperty('last_name'))){
                                _this.showSuccessMsg("'First name' and 'last name' must have at least 2 characters", "is-danger")
                            }else{
                                _this.showSuccessMsg("Something went wrong. Try again later or contact support.", "is-danger")
                            }
                        }
                    }); 
                }else{
                    _this.showSuccessMsg("All the fields are required. Try again later or contact support.", "is-danger")
                }
            }
        },
        mounted: function(){
            if(!isNullOrUndefined(this.$route.query.signup)){
                this.showRegister()
            }
        }
    }
</script>


<style scoped>
    #login-container >>> label,
    #register-container >>> label{
        text-align: left;
        padding: 0px;
        font-weight: 400;
    }

    #login-container >>> .field,
    #register-container >>> .field{
        margin-bottom: 20px;
    }

    #login-container{
        display: block;
        float: none;
        margin-left: auto;
        margin-right: auto;
        margin-top: 80px;
        margin-bottom: 50px;
        background: #fff;
        padding: 20px 40px;
        text-align: left;
        max-width: 400px;
    }

    #login-container h2{margin:20px;}
    #login-container .center{
        text-align:center;
        margin:20px;
    }

    #register-container{
        display: none;
        float: none;
        margin-left: auto;
        margin-right: auto;
        margin-top: 80px;
        margin-bottom: 50px;
        background: #fff;
        padding: 20px 40px;
        max-width: 400px;
    }

    #register-container h2{margin:20px;}
    #register-container .center{
        text-align:center;
        margin:20px;
    }

    #header{display: none;}

    @media (min-width: 768px) {
        .country-selector >>> .IZ-select__input b{
            width: auto !important;
        }
    }
    .country-selector >>> .IZ-select__item{
        padding:2px 14px !important;
        font-size:12px;
        
    }

    .country-selector >>> .IZ-select__item b{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        flex: 1;
        min-width: 0; 
        display:block;
        width:25vw;
    }

    .country-selector >>> .IZ-select__input b{
        font-size:12px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        flex: 1;
        min-width: 0;
        display:block;
        width:25vw;
    }
    .country-selector >>> .IZ-select__input.IZ-select__input--selection-slot{
        height:35px;
    }
    .country-selector >>> .IZ-select__input.IZ-select__input--selection-slot input{
        display:none;
    }
</style>